// Lightweight "saved cart" for the booking wizard — persists an in-progress
// booking to localStorage so a returning visitor can pick up where they left off.
const KEY = "cjb_saved_booking";
const EVT = "cjb-cart-change";

export function getSavedCart() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveCart(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify(data));
    window.dispatchEvent(new Event(EVT));
  } catch {
    /* storage unavailable — ignore */
  }
}

export function clearSavedCart() {
  try {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event(EVT));
  } catch {
    /* ignore */
  }
}

export function onCartChange(cb) {
  window.addEventListener(EVT, cb);
  window.addEventListener("storage", cb);
  return () => {
    window.removeEventListener(EVT, cb);
    window.removeEventListener("storage", cb);
  };
}
